<template>
  <div>
    <el-row style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="24"> 选择商品 </el-col>
    </el-row>
    <el-form :inline="true" class="demo-form-inline" style="margin-top: 20px">
      <el-form-item label="买手组">
        <el-input
          v-model="form.picker"
          size="small"
          placeholder="请输入买手组"
          style="width: 300px; margin-left: -10px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchType"
          size="small"
          placeholder="商品名称"
          style="width: 150px"
        >
          <el-option label="商品名称" value="goods_name"></el-option>
          <el-option label="商品货号" value="goods_no"></el-option>
          <el-option label="商品款号" value="goods_kh"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model.trim="searchName"
          size="small"
          placeholder="请输入"
          style="width: 300px; margin-left: -10px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          style="margin-left: -10px"
          @click="search()"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <div>
      <el-table
        ref="multipleTable"
        v-loading="tableLoading"
        :data="goodsData"
        style="width: 100%"
        height="600"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" align="center"> </el-table-column>
        <el-table-column prop="goods_kh" label="款号" align="center">
        </el-table-column>
        <el-table-column prop="goods_name" label="商品标题" align="center">
        </el-table-column>
        <el-table-column prop="goods_no" label="商品货号" align="center">
        </el-table-column>
        <el-table-column
          prop="pg_name"
          label="买手组"
          align="center"
        ></el-table-column>
        <el-table-column prop="goods_img" label="图片" align="center">
          <template slot-scope="scope">
            <div>
              <img
                style="width: 50px; height: 50px"
                :src="scope.row.goods_img"
                @click="previewImage(scope.row.goods_img)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="market_price" label="代采价" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div v-if="allData" style="text-align: right; padding: 25px">
      <el-pagination
        :current-page.sync="curPage"
        background
        layout="total, prev, pager, next, jumper "
        :total="allData.total"
        :page-size="10"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      style="width: 80%; height: auto"
      append-to-body
    >
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
    <el-row style="width: 100%">
      <div style="line-height: 30px; display: flex">
        <el-button
          style="margin-left: 80%; height: 40px; width: 80px; font-size: 16px"
          size="small"
          type="info"
          @click="closePage"
          >取消</el-button
        >
        <el-button
          style="height: 40px; width: 80px; font-size: 16px"
          size="small"
          type="warning"
          @click="addSpuGoods"
          >确认</el-button
        >
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Selectgoodslist",
  props: ["supply_id"],
  data() {
    return {
      searchType: "goods_name",
      searchName: "",
      goodsData: null,
      allData: null,
      dialogImageUrl: "",
      dialogVisible: false,
      form: {},
      model: {},
      curPage: 1,
      url: "/erp/Common/selectSPUGoodsLib",
      multipleSelection: [],
      tableLoading: false,
    };
  },
  computed: {
    filteredForm() {
      this.form.supply_id = this.supply_id;
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.form.supply_id = this.supply_id;
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.goodsData = null;
      this.allData = null;
      let url = "/erp/Common/selectSPUGoodsLib";
      this.$http.post(url, this.form).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.goodsData = res.data.data.data;
          this.allData = res.data.data;
        }
      });
    },
    search() {
      let params = {};
      if (this.searchType && this.searchName) {
        params[this.searchType] = this.searchName;
      }
      params["supply_id"] = this.supply_id;
      params["picker"] = this.form.picker;
      this.form = params;
      this.fetchData();
    },
    queryGoods(queryString) {
      if (queryString) {
        let params = {
          picker_name: this.searchCondition["picker_name"],
          pgname: this.searchCondition["pgname"],
          supply_name: this.searchCondition["supply_name"],
        };
        if (this.searchType == "goods_name") {
          params.goods_name = this.searchName;
        }
        if (this.searchType == "goods_no") {
          params.goods_no = this.searchName;
        }
        if (this.searchType == "goods_kh") {
          params.goods_kh = this.searchName;
        }
        let url = "/erp/Common/selectSPUGoodsLib";
        this.$http.post(url, params).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.goodsData = res.data.data.data;
            this.allData = res.data.data;
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.goodsData = res.data.data.data;
          this.allData = res.data.data;
        }
      });
    },
    // 确定选择商品操作
    addSpuGoods() {
      let colval_ary = [];
      let selectGoods = [];
      for (var i in this.multipleSelection) {
        colval_ary = [];
        for (var k in this.multipleSelection[i].all_item) {
          colval_ary.push({ key: k, label: k });
        }
        this.$set(this.multipleSelection[i], "colval_ary", colval_ary);
        selectGoods.push(this.multipleSelection[i]);
      }
      this.$emit("verifyAddSelectGoods", selectGoods);
    },
    // 取消,关闭页面
    closePage() {
      this.$emit("digclose");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/SelectGoodsList.vue